/*
* Pipeline Theme — custom JavaScript
*
* This file is imported from layout/theme.liquid. Pipeline ships that import
* COMMENTED OUT, so if zoom (or anything else here) stops working, check there
* first — see the [ATLAS] note next to the <script> tag.
*
* Everything must stay inside the IIFE below so nothing leaks into global scope.
* NOTE: each IIFE needs its OWN closing "})();". A missing one is a SyntaxError
* that silently kills this entire file — no console warning on the page, just
* nothing running.
*/

(function () {
  // ==========================================================================
  // [ATLAS] Make the whole product image clickable to open the PhotoSwipe zoom
  // --------------------------------------------------------------------------
  // Pipeline only opens the lightbox from a small button inside
  // .media__buttons__holder. Customers expect clicking the image itself to
  // zoom, so this forwards a click anywhere on the image to that button.
  // ==========================================================================
  function initImageClickZoom() {
    var wrappers = document.querySelectorAll('.product-image-wrapper:not([data-atlas-zoom])');
    wrappers.forEach(function (wrapper) {
      wrapper.setAttribute('data-atlas-zoom', '1'); // [ATLAS] bind once per wrapper
      wrapper.style.cursor = 'zoom-in';
      wrapper.addEventListener('click', function (e) {
        // [ATLAS] the real zoom button is inside the image — don't double-fire
        if (e.target.closest('.media__buttons__holder')) return;
        // [ATLAS] scope the lookup to THIS slide, not the whole document, or a
        // gallery with several images always opens the first one
        var cell = wrapper.closest('.flickity-cell, .product__media, li');
        var zoomBtn = cell
          ? cell.querySelector('.media__buttons__holder button')
          : wrapper.querySelector('.media__buttons__holder button');
        if (zoomBtn) zoomBtn.click();
      });
    });
  }

  // [ATLAS] Flickity builds the gallery asynchronously, so slides can appear
  // after first paint. Watch for them rather than binding once.
  var zoomObserver = new MutationObserver(function () {
    if (document.querySelector('.product-image-wrapper')) {
      initImageClickZoom();
    }
  });
  zoomObserver.observe(document.body, { childList: true, subtree: true });

  // [ATLAS] This file loads with defer, so DOMContentLoaded normally still
  // fires after it — but guard anyway in case the import is ever moved.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageClickZoom);
  } else {
    initImageClickZoom();
  }

  // [ATLAS] Switching variants swaps the gallery markup
  document.addEventListener('theme:variant:change', function () {
    setTimeout(initImageClickZoom, 300);
  });
})();

(function () {
  // ==========================================================================
  // [ATLAS] Fix #hash anchor links landing at the top of the page — Aug 2026
  // --------------------------------------------------------------------------
  // Links like /pages/faq#price-guarantee and /pages/faq#study-sets are meant
  // to jump straight to that FAQ question. The browser's native #hash jump
  // does fire on load, but this theme's entrance/reveal animation resets
  // scroll position back to the top at an unpredictable point during load
  // (confirmed via testing — a single re-scroll attempt sometimes gets
  // overwritten by that reset). Re-assert the scroll several times over the
  // first few seconds so the last attempt — after the theme's own reset has
  // already happened — is the one that sticks. Early attempts are instant so
  // we're roughly in place fast; later corrections use smooth scrolling so a
  // late correction never reads as a jarring snap to someone already reading.
  // ==========================================================================
  function scrollToHashTarget(behavior) {
    if (!window.location.hash) return;
    var id;
    try {
      id = decodeURIComponent(window.location.hash.slice(1));
    } catch (e) {
      id = window.location.hash.slice(1);
    }
    var target = document.getElementById(id);
    if (!target) return;

    // [ATLAS] Only subtract the header's height if it's actually overlaying
    // content right now (fixed/sticky). In normal flow it isn't, so no offset
    // is needed there.
    var header = document.querySelector('.theme__header');
    var headerOffset = 0;
    if (header) {
      var headerPosition = getComputedStyle(header).position;
      if (headerPosition === 'fixed' || headerPosition === 'sticky') {
        headerOffset = header.getBoundingClientRect().height;
      }
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;
    window.scrollTo({ top: top < 0 ? 0 : top, left: 0, behavior: behavior || 'instant' });
  }

  function scheduleHashScrollRetries() {
    // [ATLAS] Re-assert at several points across ~3s. Whichever attempt lands
    // after the theme's reset wins and stays put; earlier ones are harmless
    // even if immediately overwritten.
    var attempts = [
      { delay: 50, behavior: 'instant' },
      { delay: 300, behavior: 'instant' },
      { delay: 600, behavior: 'smooth' },
      { delay: 1000, behavior: 'smooth' },
      { delay: 1500, behavior: 'smooth' },
      { delay: 2200, behavior: 'smooth' },
      { delay: 3000, behavior: 'smooth' }
    ];
    attempts.forEach(function (attempt) {
      setTimeout(function () {
        scrollToHashTarget(attempt.behavior);
      }, attempt.delay);
    });
  }

  window.addEventListener('load', scheduleHashScrollRetries);

  // [ATLAS] Also handle clicking an in-page anchor link without a full
  // navigation (e.g. clicking the same FAQ link twice).
  window.addEventListener('hashchange', function () {
    setTimeout(function () {
      scrollToHashTarget('smooth');
    }, 50);
  });
})();

(function () {
  // ==========================================================================
  // [ATLAS] Readable Reverse add-on checkbox — Aug 2026 (Fable)
  // --------------------------------------------------------------------------
  // snippets/product-buttons.liquid renders a checkbox with
  // [data-readable-reverse-checkbox] inside the product form. When it's
  // checked, intercept the add-to-cart submit (capture phase, so we run
  // BEFORE the theme's own Alpine handler), add BOTH the selected plan
  // variant and the Readable Reverse product in a single /cart/add.js call,
  // then navigate to /cart — the same confirmation pattern the Study Set
  // button already uses. If anything fails, uncheck the box and fall back to
  // the theme's normal single-item add so the customer is never blocked.
  // ==========================================================================
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form]')) return;
    var box = form.querySelector('[data-readable-reverse-checkbox]');
    if (!box || !box.checked) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var rrId = parseInt(box.getAttribute('data-rr-variant-id'), 10);

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: parseInt(idInput.value, 10), quantity: qty },
          { id: rrId, quantity: 1 }
        ]
      })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[ATLAS] Readable Reverse combined add failed — falling back to normal add', err);
        if (btn) btn.classList.remove('loading');
        box.checked = false;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
  }, true); // capture phase
})();
